export enum FilterType {
  SalaryType,
  JobType,
  WorkType
}
